import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Checkbox,
  Link,
  Snackbar,
  Alert,
  useMediaQuery,
} from "@mui/material";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../FirebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import login_background from "./login_background.jpg";
import triteklogo from "./triteklogo.png";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(""); // Error message state
  const [openSnackbar, setOpenSnackbar] = useState(false); // Snackbar visibility state
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)"); // Check if the screen width is less than 600px

  const handleLogin = async () => {
    try {
      // Authenticate the user
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
  
      // Fetch user data from Firestore
      const userDocRef = doc(db, "influencers", user.uid);
      const userDocSnap = await getDoc(userDocRef);
  
      if (userDocSnap.exists()) {
        const userData = userDocSnap.data();
  
        // Navigate based on user role
        if (userData.role === "admin") {
          navigate("/admin");
        } else if (userData.role === "user") {
          navigate("/admin");
        } else {
          throw new Error("Invalid user role");
        }
      } else {
        throw new Error("User data not found in Firestore");
      }
    } catch (err) {
      console.error(err);
      // Simplified error messages
      let errorMessage = "Something went wrong. Please try again.";
      if (err.code === "auth/invalid-email") {
        errorMessage = "Invalid email address.";
      } else if (err.code === "auth/user-not-found") {
        errorMessage = "User not found.";
      } else if (err.code === "auth/wrong-password") {
        errorMessage = "Incorrect password.";
      }
      setError(errorMessage);
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <Grid container>
      {/* Left Section with Illustration */}
      {!isMobile && (
        <Grid
          item
          xs={12}
          sm={6}
          sx={{
            backgroundColor: "#f7f7f7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box component="img" src={login_background} alt="Login" sx={{ maxWidth: "100%" }} />
        </Grid>
      )}

      {/* Right Section with Form */}
      <Grid
        item
        xs={12}
        sm={isMobile ? 12 : 6}
        sx={{
          padding: 4,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Box sx={{ maxWidth: 400, width: "100%" }}>
        <img
        src={triteklogo}
        width={150}
        />
          <Typography variant="h4" sx={{ mb: 2, color: "#7D4AEA", fontWeight: "bold" }}>
            Welcome Back
          </Typography>

          <TextField
            fullWidth
            variant="outlined"
            label="Email"
            type="email"
            sx={{ mb: 2 }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Password"
            type="password"
            sx={{ mb: 2 }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Box>
              <Checkbox />
              <Typography variant="body2" component="span">
                Remember me
              </Typography>
            </Box>
            <Link href="/forgot-password" underline="hover" sx={{ color: "#7D4AEA" }}>
              Forgot Password?
            </Link>
          </Box>

          <Button
            fullWidth
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "#7D4AEA",
              color: "#fff",
              "&:hover": { backgroundColor: "#643AB0" },
              mb: 2,
            }}
            onClick={handleLogin}
          >
            Login
          </Button>

          {/* <Typography variant="body2" align="center">
            New user?{" "}
            <Link
              href="/register"
              underline="hover"
              sx={{ color: "#7D4AEA", fontWeight: "bold" }}
            >
              Register here
            </Link>
          </Typography> */}
        </Box>
      </Grid>

      {/* Snackbar for Error Messages */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="error" variant="filled" onClose={handleCloseSnackbar} sx={{ width: "100%" }}>
          {error}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default Login;
